module.exports = __webpack_public_path__ + "static/media/buenos-aires-al-aire-libre.a8937dd7.md";